export enum ContactSlugEnum {
  Email = 'email',
  FirstName = 'first_name',
  Surname = 'surname',
  Country = 'country',
  City = 'city',
  Neighborhood = 'neighborhood',
  StreetAddress = 'street_address',
  StreetNumber = 'street_number',
  Postcode = 'postcode',
  PhoneNumber = 'phone_number',
  CompanyName = 'company_name',
  TaxNumber = 'tax_number',
  State = 'state',
}
